module.exports = __webpack_public_path__ + "static/img/-s-icon yanzheng.bbe66784.svg";